import { reactive } from 'vue';

type StateType = {
  pid: string;
  taskId: string;
};

const state = reactive<StateType>({
  pid: '',
  taskId: '',
});

export default state;
